import styled from "styled-components";

const Screen = styled.div`
  width: 90%;
`;

export default Screen;
